import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import axios from 'axios';
import Footer from '../components/Footer';
import Checkout from './Checkout';
import { AddBox, RemoveCircle, DeleteForeverOutlined, FavoriteBorderOutlined,RemoveShoppingCart } from '@mui/icons-material';
// import CartProductTiles from '../components/CartProductTiles';
import { useSelector, useDispatch } from "react-redux";
import { addOne, delCart, delAllProduct } from "../redux/action";
import { Link, useNavigate, useParams} from "react-router-dom";
import { CartUpdate } from "../services/CartUpdate";
import { setHeader } from '../services/Headers';
import { Getauth } from '../services/Auth';
import { GetUserRole } from '../services/UserRole'
import { Url } from '../services/Constants';
import toast from 'react-hot-toast';
 

  
export default function BuyesDetails() {

  
  const {id} = useParams();
  const [buyerDetails, setBuyerDetails] = useState([])

  
  useEffect(() => {
    const fetchBuyerDetails = async () => {
      try {
        const response = await axios.get(`${Url}/seller/recent_buyers`, setHeader());
        const buyers = response.data.response_data.recent_buyers;
        const buyer = buyers.find(b => b.id === parseInt(id));
        setBuyerDetails(buyer);
      } catch (error) {
        console.error("Error fetching buyer details:", error);
      }
    }
    fetchBuyerDetails();
  }, [id])

  // Function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  };


  return (
    <>
      <div className="Cart-container">
        <div className="Cart-top">
          <Navbar />
        </div>
        <div className="Cart-feed relative bg-red-50 w-[95%] mx-auto  rounded-lg z-10 top-2 2xl:pb-5 mb-32 shadow-xl max-sm:mb-80">
          <div className="feed-title w-[96%] border-b-2 py-[1%] mx-auto text-left border-b-amber-950">
            <span className="text-amber-950 font-bold text-2xl">Buyer Details</span>
          </div>
          <div className="feed-containt w-[96%] flex flex-wrap justify-around max-sm:flex-col">
            <div className="feed-left w-[75%] mt-[2%]  max-sm:mx-auto max-xl:w-[70%] max-lg:w-[65%] max-sm:w-[90%]">
            
            <div className="products bg-white shadow-2xl rounded-lg mb-1 ">
              <div className="products p-[2%] flex flex-wrap md:flex-nowrap max-sm:flex-col">
                    <div className="left w-[30%] max-lg:w-[30%] flex cursor-pointer group max-sm:w-full">
                      <img src={buyerDetails.profile_pic && buyerDetails.profile_pic.length > 0 ? buyerDetails.profile_pic : '/assets/profile_pic.webp'}  alt="product-image" className="min-w-32 min-h-32 max-lg:h-36 max-sm:mx-auto border-4 border-amber-950 rounded-xl group-hover:opacity-50"/>
                    </div>
                    <div className="right mx-[2%] w-full ">
                      <div className="buyer-name w-[90%] text-amber-950 text-2xl font-bold mb-3 flex justify-between cursor-pointer">
                          {buyerDetails.name}
                          </div>
                          <div className="product-name w-[90%] text-amber-950 text-lg flex mb-2 justify-between cursor-pointer">
                          {buyerDetails.product_name}
                          </div>
                          <div className="orderId w-[90%] text-amber-950 text-sm flex mb-5 justify-between cursor-pointer">
                          {buyerDetails.order_id}
                          </div>
                          <div className="orderId w-[90%] cursor-default mb-5 max-sm:mb-2">
                          <span className="price text-lg font-bold ">Rs.{buyerDetails.product_variant_price}</span><span className='qty text-xs ml-5'>Qty: {buyerDetails.order_product_variant_quantity}</span>
                          </div>
                          <div className="orderId w-[90%] text-sm max-sm:mb-5">
                          {buyerDetails.order_status_date && formatDate(buyerDetails.order_status_date)}
                          </div>
                    </div>
                    <div className="productImg text">
                        <img src={buyerDetails.product_images && buyerDetails.product_images.length > 0 ? buyerDetails.product_images[0].image : '/assets/fallback-image-url.jpg'} alt="img" className='mb-2 max-sm:h-32 max-sm:w-32 max-sm:mx-auto' />
                        <div className="status text-center border rounded-sm w-[70%] text-amber-950 font-medium mx-auto">{buyerDetails.order_status}</div>
                    </div>
              </div>
                <div className="specification p-[2%]">
                    <div className="title text-amber-950 font-bold text-xl mb-2">Specification</div>
                <div className="k">{buyerDetails.specification}</div>
            </div>
            </div>
            </div>



           <div className="feed-right w-[20%] my-[2%] max-xl:w-[25%] max-lg:w-[30%] max-sm:w-[90%] max-sm:mx-auto">
              {/* Desktop Cart Summary */}
              <div className="bg-white rounded-lg shadow-xl p-[4%]">
                <div className="pri border-b-2 border-b-amber-950 flex justify-between p-2">
                    <span className="k text-amber-950 font-bold">Price</span><span className="k text-amber-950 font-medium">{buyerDetails.product_variant_price}</span>
                </div>
                <div className="pri border-b-2 border-b-amber-950 flex justify-between p-2">
                    <span className="k text-amber-950 font-bold">Address</span>
                    <div className='flex flex-col w-[40%]'>
                    <span className="k text-amber-950 font-normal text-right mb-2">Shipping to, </span>
                    <span className="k text-amber-950 font-normal text-right"> {buyerDetails.street_address}, {buyerDetails.city}, {buyerDetails.state}, {buyerDetails.pincode}</span>
                    </div>
                </div>
                <div className="pri border-b-2 border-b-amber-950 justify-between p-2">
                <div className='flex justify-between '>
                    <span className="k text-amber-950 font-bold ">Qty </span>
                    <span className="k text-amber-950 font-medium"> 10</span>
                    </div>
                    <div className='flex justify-between '>
                    <span className="k text-amber-950 font-bold ">Total Price </span>
                    <span className="k text-amber-950 font-medium"> {buyerDetails.final_discounted_price}</span>
                    </div>
                    <div className='flex justify-between '>
                    <span className="k text-amber-950 font-bold">GST </span>
                    <span className="k text-amber-950 font-medium"> {buyerDetails.total_gst}%</span>
                    </div>
                    <div className='flex justify-between '>
                    <span className="k text-amber-950 font-bold">Discount </span>
                    <span className="k text-amber-950 font-medium"> 10%</span>
                    </div>
                </div>
                <div className="pri  flex justify-between p-2">
                    <span className="k text-amber-950 font-bold">Grand Total</span><span className="k text-amber-950 font-medium">{buyerDetails.grand_total_price}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-40">
        </div>
        <div className="Cart-bottom mb-0 fixed w-full bottom-0 z-20 ">
          <Footer />
        </div>
      </div>
    </>
  );
}
